type updateSubscriptionPlanProps = {
  productId: string
}

export const updateSubscriptionPlan = async ({ productId }: updateSubscriptionPlanProps) => {
  const { fetchAuthenticityToken } = await import("app/scripts/refresh_form_authenticity_token")

  const response = await fetch("/billing/update_subscription_plan", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": await fetchAuthenticityToken(),
      "x-requested-with": "XMLHttpRequest",
    },
    body: JSON.stringify({
      product_id: productId,
    }),
  })

  return response.json()
}

export const loadSubscriptionDetails = async (url: string) => {
  return fetch(url, {
    headers: { "Content-Type": "application/json" },
  }).then(response => response.json())
}

type ChangeBillingIntervalProps = {
  targetInterval: "month" | "year"
  priceId: string
}

export const changeBillingInterval = async ({ targetInterval, priceId }: ChangeBillingIntervalProps) => {
  const { fetchAuthenticityToken } = await import("app/scripts/refresh_form_authenticity_token")

  const response = await fetch("/billing/change_billing_interval", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": await fetchAuthenticityToken(),
      "x-requested-with": "XMLHttpRequest",
    },
    body: JSON.stringify({
      target_interval: targetInterval,
      price_id: priceId,
    }),
  })

  return response.json()
}
